export default __webpack_public_path__ + "static/media/kanban-view.82e26aaf.svg";